module.exports = __webpack_public_path__ + "img/education.b4ffde1e.png";